import React, { FC, useState, Fragment } from 'react';
import ImgCrop from 'antd-img-crop';
import { Button } from 'antd';
import { UploadOutlined, FileImageOutlined } from '@ant-design/icons';
import { noop } from 'lodash';

import { getBase64 } from '../../../../shared/utils';

import {
  HeaderImagePreviewContainer,
  HeaderImagePreview,
  HeaderImage,
  UploadStyled,
  ImageUploadContainer,
  Label,
  ButtonLabelContainer,
} from './styled';

interface IUpload {
  onChange?: (file: any) => void;
  value?: string;
  aspectRatio: number;
  uploadButtonText?: string;
  label?: string;
  buttonLabel?: string;
  crop?: boolean;
  acceptedMimeTypes?: string;
  rounded?: boolean;
}

export const ImageUpload: FC<IUpload> = ({
  onChange = noop,
  uploadButtonText = 'Titelbild hochladen',
  aspectRatio,
  value = undefined,
  label = '',
  buttonLabel = '',
  crop = false,
  rounded = false,
  acceptedMimeTypes = 'image/jpg,image/jpeg,image/png',
}) => {
  const [preview, setPreview] = useState<any>(value);
  const cropProps = crop
    ? {
      zoom: true,
      rotate: true,
      fillColor: 'transparent',
      aspect: aspectRatio,
    }
    : {};

  /**
   * Render ImgCrop component conditionally
   */
  // eslint-disable-next-line no-constant-condition
  const CropMaybe = false ? ImgCrop : Fragment;

  /**
   * customRequest
   *
   *  This function tricks ant upload field buildin ajax request (we use graphql).
   */
  const customRequest = ({ onSuccess }: any) => {
    setTimeout(() => onSuccess('ok'));
  };

  /**
   * onFileChange
   */
  const onFileChange = async ({ file }: any) => {
    onChange(file.originFileObj);

    if (file) {
      const base64 = await getBase64(file.originFileObj);

      setPreview(base64);
    } else {
      setPreview(null);
    }
  };

  return (
    <ImageUploadContainer>
      {label && <Label>{label}</Label>}

      <HeaderImagePreviewContainer rounded={rounded}>
        <HeaderImagePreview aspectRatio={aspectRatio}>
          {!preview && (
            <FileImageOutlined
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate3d(-50%, -50%, 0)',
                fontSize: 40,
                color: '#ccc',
              }}
            />
          )}

          {preview && <HeaderImage src={preview} rounded={rounded} />}
        </HeaderImagePreview>
      </HeaderImagePreviewContainer>

      <CropMaybe {...cropProps}>
        <UploadStyled
          onChange={onFileChange}
          customRequest={customRequest}
          multiple={false}
          accept={acceptedMimeTypes}
        >
          <Button style={{ marginRight: 10 }}>
            <UploadOutlined /> {uploadButtonText}
          </Button>

          <ButtonLabelContainer>{buttonLabel}</ButtonLabelContainer>
        </UploadStyled>
      </CropMaybe>
    </ImageUploadContainer>
  );
};
